import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import {computed} from 'vue';
import {Screen} from 'quasar';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvertDetailAd',
  setup(__props) {

const imgSrcCmp = computed(() => {
  let imgSrc = ''

  if (Screen.lt.md) {
    imgSrc = require('src/assets/ads/horbach/horbach_16_9_w1000.webp')
  } else {
    imgSrc = require('src/assets/ads/horbach/horbach_3_1_w1000.webp')
  }
  return imgSrc
})

const adUrl = computed(() => {
  return 'https://www.wohnmobile-versichern.de/?utm_source=campertrader&utm_medium=banner&utm_campaign=campertrader-partner'
})

const containerAttrs = computed(() => {
  const style = {}

  if (Screen.lt.md) {
    style['aspectRatio'] = 16 / 9
  } else {
    style['aspectRatio'] = 3
  }
  return {
    style: style,
  }
})

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("a", {
    rel: "external nofollow noreferrer noopener",
    href: adUrl.value,
    referrerpolicy: "no-referrer-when-downgrade",
    target: "_blank"
  }, [
    _createElementVNode("div", _mergeProps({ class: "relative-position bg-grey-3 rounded-borders overflow-hidden" }, containerAttrs.value), [
      _createVNode(_component_q_img, {
        "no-spinner": "",
        src: imgSrcCmp.value
      }, null, 8, ["src"])
    ], 16)
  ], 8, _hoisted_1))
}
}

})